import React from 'react';
import styles from './OrderTable.module.scss';
import { XPagination, XTableSelectionCount, XTableHOC } from '@/components/xqxc_ui';
import { Table } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { regFenToYuan } from '@/util/money';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';

class OrderTable extends React.Component {

    state = {
        selectedRowKeys: []
    }
    _takeColumnsMulti = () => ([
        {
            title: '订单批号',
            dataIndex: 'deliveryGroupId',
            key: 'deliveryGroupId',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => tooltipClick(text, () => {
                this.props.tableAction(item.deliveryGroupId, 'multiinfo', item);
            })
        },
        {
            title: '订单实付金额',
            dataIndex: 'groupPayAmount',
            key: 'groupPayAmount',
            width: cellWidth.normal,
            align: 'center',
            render: (text) => (this._renderTextMoneyCell(text))
        },
        {
            title: '小费',
            dataIndex: 'groupTips',
            key: 'groupTips',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text) => (this._renderTextMoneyCell(text))
        },
        {
            title: '支付通道',
            dataIndex: 'payAccessType',
            key: 'payAccessType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '支付方式',
            dataIndex: 'payType',
            key: 'payType',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '发货人',
            dataIndex: 'shipperPhone',
            key: 'shipperPhone',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },{
            title: '下单时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
    ]);

    _takeDataSource = (dataList) => {
        if (dataList) {
            return dataList;
        } else {
            return [];
        }
    }
    _renderTextMoneyCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {regFenToYuan(text)}
            </div>
        );
    }
    _renderTextCell = (text) => {
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {text}
            </div>
        );
    };
    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, 'history', record)}>订单日志</div>
            </div>
        );
    };

    // 表格复选输入
    _rowSelection = () => {
        const { selectedRowKeys } = this.state;
        return {
            selectedRowKeys,
            onChange: (selectedRowKeys) => {
                this.setState({ selectedRowKeys });
                this.props.tableAction(null, 'batch', [...selectedRowKeys]);
            }
        };
    };

    // 清空表格复选框
    _cleanAllSelected = () => {
        this.setState({ selectedRowKeys: [] });
        this.props.tableAction(null, 'batch', []);
    }

    render() {
        const { selectedRowKeys } = this.state;
        const { paginationChange, curTabID } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                {/* <XTableSelectionCount selectedNum={selectedRowKeys.length} onClean={this._cleanAllSelected} /> */}
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    // rowSelection={this._rowSelection()}
                    rowKey={record => record.deliveryGroupId}
                    columns={this._takeColumnsMulti()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

OrderTable.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    scrollY: PropTypes.string,
    curTabID: PropTypes.number
};

export default OrderTable;
